import {
  REQUEST_LANGUAGES_INFORMATION,
  SAVE_CHANGES_TO_LANGUAGES
} from './types.js';
import {
  getSelectedFarmLanguagesInformationSuccess,
  getSelectedFarmLanguagesInformationError,
  saveChangesToSelectedFarmLanguagesSuccess,
  saveChangesToSelectedFarmLanguagesError
} from './actions.js';
import { put, take, call } from 'redux-saga/effects';
import {
  startLoading,
  endLoading,
} from '../../../common/redux/loadManager/actions';
import { getLoadId } from '../../../common/redux/loadManager/methods';

let currentLoadId = 0;


export function* farmLanguagesSaga(api) {
  while (true) {
    const selectedFarmLanguagesInformationRequestAction = yield take(
      REQUEST_LANGUAGES_INFORMATION,
    );
    /** Run loader */
    currentLoadId = getLoadId();
    yield put(startLoading(currentLoadId));
    const { accessToken } = selectedFarmLanguagesInformationRequestAction.payload;
    yield call(getLanguagesDetails, api, accessToken);
  }
}

/** Create request to get selected farm languages latest state of data from the backend
 * @param {string} accessToken - User access token
 */
function* getLanguagesDetails(api, accessToken) {
  try {
    const languagesDetails = yield call(
      api.getSelectedFarmLanguages,
      accessToken,
    );
    yield put(getSelectedFarmLanguagesInformationSuccess(languagesDetails.data));
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  } catch (error) {
    /** Error code parsed to string   */
    const errorCode = error && error.toString().substr(-3);
    yield put(getSelectedFarmLanguagesInformationError(error));
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  }
}

export function* farmLanguagesSaveChangesSaga(api) {
  while (true) {
    const saveChangesRequestAction = yield take(
      SAVE_CHANGES_TO_LANGUAGES,
    );
    /** Run loader */
    currentLoadId = getLoadId();
    yield put(startLoading(currentLoadId));
    const { accessToken, newLanguageDetails } =
      saveChangesRequestAction.payload;
    yield call(
      saveChangesToSelectedFarmLanguages,
      api,
      accessToken,
      newLanguageDetails,
    );
  }
}

/** Create request to get animals page latest state of data from the backend
 * @param {string} accessToken - User access token
 * @param {Object} newLanguageDetails - The latest state of the selected farm languages data coming directly from the frontend which we want to persist on the backend
 */
function* saveChangesToSelectedFarmLanguages(
  api,
  accessToken,
  newLanguageDetails,
) {
  try {
    const updateFarmLanguagesDataResponse = yield call(
      api.setSelectedFarmLanguages,
      accessToken,
      newLanguageDetails
    );
    yield put(
      saveChangesToSelectedFarmLanguagesSuccess(updateFarmLanguagesDataResponse.data),
    );
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  } catch (error) {
    /** Error code parsed to string   */
    const errorCode = error && error.toString().substr(-3);
    yield put(saveChangesToSelectedFarmLanguagesError(error));
    /** Stop loader */
    yield put(endLoading(currentLoadId));
  }
}
